function parseDimension ({ width = {}, height = {} }) {
  return {
    width: width.value + width.unit,
    height: height.value + height.unit
  }
}

export default parseDimension
